import React, { useEffect } from "react"
import {
  matchPath,
  Redirect,
  Route,
  Switch,
  useLocation,
} from "react-router-dom"

import { useSelector } from "react-redux"
import { RootState } from "./globalStore/rootreducer"
import { allPages } from "./constant/pages"
import { メニュー分類, 分類リスト } from "./constant/categories"
import PageList from "./features/PageList/PageList"
import { LOCALSTORAGE_PROPERTIES } from "./constant/localstorageProperties"
import constants from "./constant/constant"

/**
 * routerのURL設定コンポーネント
 */
const RootContainer = () => {
  const pages = useSelector((state: RootState) => state.menu.menuPage)
  const location = useLocation()
  const localStorageMenuCodeString: string =
    localStorage.getItem(LOCALSTORAGE_PROPERTIES.PERMISSION_PAGES) ?? ""

  // ロケーション変更時にページ名を入れる
  useEffect(() => {
    const matchObject = allPages.find(
      (page) =>
        !!matchPath(location.pathname, {
          path: page.Route.path,
          exact: true,
          strict: true,
        })
    )

    if (matchObject) {
      document.title = `${constants.APP_NAME} - 大川運輸 - ${matchObject.機能名}`
      return
    }
  }, [location.pathname])

  return (
    <Switch>
      {/* メニュー一覧 */}
      <Route
        exact
        path={分類リスト
          .filter((b) => b.分類コード !== メニュー分類.トップ)
          .map((b) => b.url)}
        component={PageList}
      />
      {allPages
        .filter((p) => {
          // リロード対策にローカルストレージもしくはstoreのどちらかにいれば表示する
          return (
            pages.find((ps) => ps.メニューコード === p.メニューコード) ||
            localStorageMenuCodeString.includes(p.メニューコード)
          )
        })
        .map((page, i) => {
          return <Route key={i} {...page.Route} />
        })}

      {/* リダイレクト用 */}
      <Redirect from="/" to={"/top"} />
    </Switch>
  )
}
export default RootContainer
